import React, { useState } from "react";
import { View, StyleSheet, Modal } from "react-native";
import { TextInput } from "react-native";
import config from "../../config/config";
import AppButton from "../AppButton";
import AppText from "../AppText";
import IconTouchable from "../IconTouchable";
import ListItem from "./ListItem";
import ListItemSeperator from "./ListItemSeperator";

function ListItemTextInputNew({
    itemID = false,
    title,
    onComplete = () => {},
    onChange = () => {},
    value,
    numberInput = false,
    maxLength,
    autoFocus,
    setValue = () => {},
    footer,
    editable,
}) {
    const [newTextValue, setNewTextValue] = useState(value);
    const [modalVisible, setModalVisible] = useState(false);

    const handleSubmit = async () => {
        if (newTextValue == value) {
            setModalVisible(false);
            return;
        }
        if (itemID) {
            await onComplete.request(itemID, newTextValue);
        } else {
            onComplete(newTextValue);
        }

        setModalVisible(false);
    };

    return (
        <>
            <ListItem
                title={title}
                subTitle={newTextValue ? newTextValue : false}
                subTitle2={footer}
                utilityComponent={editable && <IconTouchable name="pencil" onPress={() => setModalVisible(true)} />}
            />

            <Modal animationType="slide" transparent={true} visible={modalVisible}>
                <View style={styles.modalView}>
                    <View style={{ paddingBottom: 20 }}>
                        <AppText>{title}</AppText>
                    </View>
                    <View style={styles.inputBox}>
                        <TextInput
                            spellCheck={false}
                            autoCorrect={false}
                            autoFocus={autoFocus}
                            style={config.text}
                            multiline={true}
                            onChangeText={(text) => {
                                if (numberInput) {
                                    setNewTextValue(text.replace(/[^0-9]/g, ""));
                                    onChange(text.replace(/[^0-9]/g, ""));
                                } else {
                                    setNewTextValue(text);
                                    onChange(text);
                                }
                                setValue(text);
                            }}
                            value={newTextValue}
                            keyboardType={numberInput ? "numeric" : "default"}
                            placeholder={numberInput ? "0" : title}
                            placeholderTextColor={config.colors.danger}
                            maxLength={maxLength}
                            hitSlop={{ top: 20, bottom: 20, left: 80, right: 80 }}
                            textAlign={"center"}
                        />
                    </View>
                    <View style={{ flexDirection: "row", paddingTop: 20, justifyContent: "space-between" }}>
                        <AppButton title={"cancel"} color={config.colors.tertiary} onPress={() => setModalVisible(false)} width={120} />
                        <AppButton title={"Confirm"} color={config.colors.tertiary} onPress={() => handleSubmit()} width={120} />
                    </View>
                </View>
            </Modal>
        </>
    );
}

const styles = StyleSheet.create({
    inputBox: {
        backgroundColor: config.colors.light,
        borderRadius: 25,
        width: "90%",
        padding: 10,
    },
    modalView: {
        top: "35%",
        justifyContent: "center",
        alignItems: "center",
        margin: 20,
        backgroundColor: config.colors.white,
        borderRadius: 20,
        padding: 20,
        alignItems: "center",
        shadowColor: "#000",
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 5,
        borderColor: config.colors.tertiary,
        borderWidth: 6,
    },
});

export default ListItemTextInputNew;
